import people from "./people"
import companies from "./companies"

export default [...people, ...companies]
